var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JCB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2311 8.28727C16.7889 8.29844 17.3497 8.26459 17.9052 8.30485C18.4677 8.40152 18.6033 9.18589 18.1035 9.44278C17.7625 9.61202 17.3575 9.50582 16.9878 9.53567H16.2311V8.28727ZM18.2277 6.87425C18.3516 7.27708 17.93 7.63876 17.5087 7.58329H16.2311C16.2401 7.20341 16.2136 6.79109 16.2441 6.43121C16.7559 6.44448 17.2725 6.40413 17.7813 6.45231C17.9999 6.5029 18.1829 6.66844 18.2277 6.87425ZM21.3024 0.900419C21.3261 1.66972 21.3058 2.47968 21.3126 3.26459C21.3111 6.45573 21.316 9.64679 21.3099 12.8381C21.2875 14.0341 20.1367 15.0733 18.8472 15.0971C17.5565 15.102 16.2656 15.0979 14.9747 15.0992V10.2749C16.3812 10.2682 17.7884 10.2884 19.1943 10.2647C19.8466 10.227 20.561 9.83067 20.5913 9.16959C20.6681 8.50565 19.9885 8.04643 19.3433 7.9739C19.0952 7.96796 19.1025 7.9073 19.3433 7.88084C19.9587 7.75833 20.4419 7.17167 20.2609 6.58413C20.1066 5.96618 19.365 5.72701 18.7482 5.72819C17.4906 5.72032 16.2327 5.72709 14.975 5.72481C14.9831 4.82416 14.958 3.92255 14.9885 3.02256C15.0881 1.84819 16.2678 0.879714 17.5392 0.900726C18.7937 0.90055 20.0481 0.90055 21.3024 0.900507V0.900419Z",
    fill: "url(#paint0_linear_104_110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.762335 3.14441C0.794454 1.95034 1.95012 0.919671 3.23794 0.90222C4.52391 0.898571 5.81006 0.901693 7.09602 0.900638C7.09248 4.89572 7.10298 8.89125 7.09072 12.8861C7.04118 14.0657 5.89811 15.0767 4.62432 15.0976C3.33592 15.1019 2.04739 15.0982 0.758946 15.0994V10.1124C2.01045 10.3847 3.32285 10.5006 4.5996 10.32C5.36277 10.2069 6.19778 9.8617 6.45616 9.13244C6.6463 8.50864 6.53925 7.85213 6.56755 7.21189V5.72503H4.35801C4.34808 6.7084 4.37834 7.69349 4.34202 8.67568C4.28246 9.27939 3.63335 9.66297 3.01516 9.64248C2.2485 9.64996 0.72926 9.13073 0.72926 9.13073C0.725442 7.28829 0.751501 4.98091 0.762335 3.14458V3.14441Z",
    fill: "url(#paint1_linear_104_110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.92004 6.32498C7.80373 6.34771 7.89665 5.96009 7.86692 5.81305C7.87484 4.88335 7.85036 3.95263 7.88043 3.02359C7.97979 1.84425 9.16857 0.87336 10.4451 0.900965H14.2043C14.2007 4.89605 14.2112 8.89157 14.199 12.8864C14.1494 14.066 13.0062 15.077 11.7324 15.0979C10.444 15.1024 9.1554 15.0986 7.86687 15.0997V9.63582C8.74687 10.3009 9.94291 10.4044 11.0393 10.4062C11.8658 10.4059 12.6874 10.2885 13.4901 10.113V9.11198C12.5855 9.5272 11.5222 9.79095 10.5195 9.55239C9.82007 9.39203 9.31232 8.76942 9.32363 8.10456C9.2426 7.41315 9.68262 6.68319 10.4203 6.47764C11.3362 6.21355 12.3344 6.41553 13.1929 6.75888C13.3769 6.84759 13.5636 6.95762 13.49 6.67444V5.88764C12.0542 5.573 10.5261 5.45721 9.08358 5.79951C8.66603 5.908 8.25922 6.07253 7.92004 6.32507V6.32498Z",
    fill: "url(#paint2_linear_104_110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_110",
    x1: 14.9314,
    y1: 7.69623,
    x2: 21.2727,
    y2: 7.69623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_104_110",
    x1: 0.624117,
    y1: 8.13598,
    x2: 6.99211,
    y2: 8.13598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_104_110",
    x1: 7.85758,
    y1: 7.83432,
    x2: 14.2031,
    y2: 7.83432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.26fd4bde6f2a70a1b946a24b1c1cc136.svg";
export { ForwardRef as ReactComponent };